import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .required("Please enter name")
      .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
      .min(2, "Name must be at least 2 characters in length")
      .max(50, "Name must be at most 50 characters in length"),
    email: Yup.string()
      .email("The email you have entered is invalid")
      .max(60, "Max length of 60 characters")
      .trim()
      .required("Please enter email"),
    password: Yup.string()
      .required("Please enter password")
      .min(8, "Password must be of at least 8 characters in length")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter"),
    phone_number: Yup.string()
      .required("Please enter phone number")
      .matches(/^[0-9]+$/, "Please enter a valid  phone number")
      .min(10, "Please enter a valid  phone number")
      .max(10, "Please enter a valid  phone number"),
    terms_condition: Yup.boolean().oneOf(
      [true],
      "Please check terms and condition"
    )
  }),
  mapPropsToValues: props => ({
    name: "",
    email: "",
    password: "",
    phone_number: "",
    terms_condition: false
  }),
  handleSubmit: values => {},
  validateOnMount: true,
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
